import { makeSure } from '@/tools';
import dateFormat from '@/tools/dateFormat.js';
import { addQueryToConfig } from './util';
export default class TableRenderClass {
  selfField = new Map();
  selfSearch = new Map();
  constructor(obj = { fields: {}, search: [] }) {
    if (!(this instanceof TableRenderClass)) {
      console.warn(
        'TableRenderClass is a constructor and should be called with the `new` keyword'
      );
    }
    this.fields = obj.fields;
    this.handleFields(obj.fields);
    this.searchs = obj.search;
    this.handleSearchs(obj.search);
  }
  handleSearchs(list) {
    if (Array.isArray(list)) {
      for (let i of list) {
        //todo 对type是不是需要特殊处理
        let key = i.id || i.tip || i.key || i.type;
        if (!key) {
          console.error('表格search初始化失败,需要id或者key字段', i);
          return;
        }
        if (this.selfSearch.has(key)) {
          console.warn('search列表中,出现重复的key:', key);
        }
        this.selfSearch.set(key, i);
      }
    } else if (Object.prototype.toString.call(list) === '[object Object]') {
      for (let i of Object.keys(list)) {
        this.selfSearch.set(i, list[i]);
      }
    }
  }
  handleFields(list) {
    if (Array.isArray(list)) {
      for (let i of list) {
        let key = i.id || i.key;
        if (!key) {
          console.error('表格fields初始化失败,需要id或者key字段', i);
          return;
        }
        if (this.selfField.has(key)) {
          console.warn('fields列表中,出现重复的key:', key);
        }
        this.selfField.set(key, i);
      }
    } else if (Object.prototype.toString.call(list) === '[object Object]') {
      for (let i of Object.keys(list)) {
        this.selfField.set(i, list[i]);
      }
    }
  }
  //处理search
  getSearchs(keyArr = []) {
    let res = [];
    if (!Array.isArray(keyArr)) {
      console.error('表格搜索配置,需传入数组');
      return;
    }
    for (let i of keyArr) {
      if (typeof i === 'string') {
        this.selfSearch.has(i) && res.push(this.selfSearch.get(i));
      } else if (Object.prototype.toString.call(i) === '[object Object]') {
        if (this.selfSearch.has(i.id)) {
          res.push({ ...this.selfSearch.get(i.id), ...i });
        } else {
          res.push(i);
        }
      }
    }
    return res;
  }

  // 处理表格字段
  getFields(keyArr) {
    if (!Array.isArray(keyArr)) {
      console.error('表格field配置,需传入数组');
      return;
    }
    let res = [];
    for (let i of keyArr) {
      if (typeof i === 'string') {
        this.selfField.has(i) && res.push(this.selfField.get(i));
      } else if (Object.prototype.toString.call(i) === '[object Object]') {
        if (this.selfField.has(i.id)) {
          res.push({ ...this.selfField.get(i.id), ...i });
        } else {
          res.push(i);
        }
      }
    }
    return res;
  }
  createPart(
    obj = {
      fields: [],
      search: [],
      moreBtnArr: [],
      showClearAll,
      beforeSearch: () => {},
      list: null,
      requestNow: false,
      defaultQuery: {},
      defaultQueryHotfix: {}
    }
  ) {
    let fieldsList = this.getFields(obj.fields);
    let searchList = this.getSearchs(obj.search);
    return new TablePartClass({
      fields: fieldsList,
      search: searchList,
      name: obj.name,
      moreBtnArr: obj.moreBtnArr,
      showClearAll: obj.showClearAll,
      beforeSearch: obj.beforeSearch,
      list: obj.list,
      defaultQuery: obj.defaultQuery,
      defaultQueryHotfix: obj.defaultQueryHotfix
    });
  }
}
export class TablePartClass {
  constructor({
    list = null,
    moreBtnArr = [],
    showClearAll,
    beforeSearch = () => {},
    fields = [],
    search = [],
    name,
    defaultQuery = {},
    defaultQueryHotfix = {}
  } = {}) {
    this.list = list;
    this.ajax = list;
    this.moreBtnArr = moreBtnArr;
    this.showClearAll = showClearAll;
    this.fields = fields;
    this.search = search;
    this.name = name;
    this.beforeSearch = beforeSearch;
    this.defaultQuery = defaultQuery;
    this.defaultQueryHotfix = defaultQueryHotfix;
  }
  addQuery(ajax, query) {
    return function(data) {
      data = Object.assign({}, query, data);
      return ajax.call(null, data);
    };
  }
}
